import React from "react"
import {
    MdOutlineGifBox,
    MdOutlineImage,
    MdOutlineInsertDriveFile,
    MdOutlineLocationOn,
    MdOutlineMicNone,
    MdOutlineRefresh,
    MdOutlineVideocam,
} from "react-icons/md"
import styles from "./mediaUnavailable.module.css"

const mediaData = {
    audio: { icon: <MdOutlineMicNone />, label: "Áudio indisponível" },
    gif: { icon: <MdOutlineGifBox />, label: "GIF indisponível" },
    image: { icon: <MdOutlineImage />, label: "Imagem indisponível" },
    location: { icon: <MdOutlineLocationOn />, label: "Mapa indisponível" },
    sticker: { icon: <MdOutlineImage />, label: "Figurinha indisponível" },
    video: { icon: <MdOutlineVideocam />, label: "Vídeo indisponível" },
}

const MediaUnavailable = ({ type = "file", compact = false, onRetry }) => {
    const data = mediaData[type] || {
        icon: <MdOutlineInsertDriveFile />,
        label: "Arquivo indisponível",
    }

    return (
        <div
            className={`${styles.container} ${styles[type] || ""} ${compact ? styles.compact : ""}`}
            role="group"
            aria-label={`${data.label}. O arquivo pode ter expirado ou estar temporariamente indisponível.`}
        >
            <span className={styles.icon} aria-hidden="true">{data.icon}</span>
            <span className={styles.copy}>
                <strong>{data.label}</strong>
                {!compact && <small>O arquivo pode ter expirado ou estar temporariamente indisponível</small>}
            </span>
            {!compact && typeof onRetry === "function" && (
                <button type="button" onClick={onRetry} title="Tentar carregar novamente" aria-label={`Tentar carregar ${data.label.toLowerCase()} novamente`}>
                    <MdOutlineRefresh />
                </button>
            )}
        </div>
    )
}

export default MediaUnavailable
